export default "__VITE_ASSET__DxrGUfn1__"